// extracted by mini-css-extract-plugin
module.exports = {"organization":"Organization_organization__2a3aL","content":"Organization_content__3-Tog"};